module.exports = __webpack_public_path__ + "img/financialPlan.c27089b3.svg";